import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutModule, SharedModule } from '@app/shared';
import { MaterialModule } from '@app/shared/material.module';
import {
     StockOrderAddEditComponent,  stockOrderDeclarationComponents,
    StockOrderInterbranchModalComponent, StockOrderModelComponent, StockOrderRoutingModule
} from '@inventory/components/stock-order';
import { NgxPrintModule } from 'ngx-print';
import { RequisitionCreationModalComponent } from './add-edit-list/requisition-creation-modal.component';
import { StockInfoModalComponent } from './add-edit-list/stock-info-modal.component';

@NgModule({
  declarations: [ ...stockOrderDeclarationComponents ],

  imports: [
    CommonModule,
    StockOrderRoutingModule,
    LayoutModule,
    MaterialModule,
    SharedModule,
    NgxPrintModule
  ],

  entryComponents: [StockOrderAddEditComponent, StockOrderInterbranchModalComponent, StockOrderModelComponent, RequisitionCreationModalComponent, StockInfoModalComponent]
})
export class StockOrderModule { }